import React, { useState, useEffect, useContext } from 'react'
import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import { Helmet } from "react-helmet-async";
import { searchFromHash } from '../../services/search'
import { breadcrumbsBy } from '../../services/locations'
import FeedAccount from "../comment/FeedAccount"
import { Link } from 'react-router-dom'
import { objToEncoded } from '../../services/search'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

export default ({}) => {

    const { data, postServices, location } = useContext(AppContext)
    const user = data?.app?.user
    const search = searchFromHash()
    const types = [
        {
            type: 'discussion',
            label: 'Discussion'
        },
        {
            type: 'admin-comments',
            label: 'Admin Comments'
        },
        {
            type: 'communication',
            label: 'Communication'
        }
    ]
    const [ commentable, setCommentable ] = useState(null)
    const commentableLabel = search?.commentable_type == 'App\\Post' ? 'Post' : 'Object'
    const hasThread = search?.commentable_type && search?.commentable_id ? true : false
    let breadcrumbs = [
        { url: '/account', title: 'Dashboard' },
    ];
    if(search?.commentable_type == 'App\\Post') breadcrumbs.push({ url: '/account/posts', title: 'Posts'})
    breadcrumbs.push({ title: 'Communicate' })

    return (
        <>
            <div>
                <Header history={history} fluid={true} />
                <main className="py-4">
                    <div className="container-fluid">
                        <Breadcrumbs
                            list={breadcrumbsBy(location, breadcrumbs)}
                        />
                        <Helmet><title>{'Communicate | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        {hasThread ? (
                            <>
                                {commentable &&
                                    <div className="d-flex justify-content-between mb-3">
                                        <h4 className="h4 mt-1 me-3">
                                            {commentableLabel}:&nbsp;
                                            <a href={commentable.url} className="me-2">{commentable.title}</a>
                                            {commentable.user.full_name &&
                                                <small className="text-muted">(by {commentable.user.full_name})</small>
                                            }
                                        </h4>
                                        {user?.type == 'admin' &&
                                            <div className="text-center">
                                                <a href={`/admin/resources/posts?posts_filter=W3siY2xhc3MiOiJBcHBcXE5vdmFcXEZpbHRlcnNcXFBvc3RUeXBlIiwidmFsdWUiOnsiMCI6dHJ1ZSwiMSI6dHJ1ZSwiMiI6dHJ1ZSwiMyI6dHJ1ZSwiNCI6dHJ1ZSwiNSI6dHJ1ZSwiNiI6dHJ1ZSwiNyI6dHJ1ZSwiOCI6dHJ1ZSwiOSI6dHJ1ZSwiMTAiOnRydWUsIjExIjp0cnVlLCIxMiI6dHJ1ZSwiMTMiOnRydWV9fSx7ImNsYXNzIjoiQXBwXFxOb3ZhXFxGaWx0ZXJzXFxJbXBvcnRlZCIsInZhbHVlIjp7Im9ubHkiOmZhbHNlLCJleGNlcHQiOmZhbHNlLCJmb3Itc2FsZSI6ZmFsc2UsIm5ld3MiOmZhbHNlLCJleGNlcHQtbmV3cyI6dHJ1ZX19XQ%3D%3D&posts_search=${commentable.post_id}`} target="_blank">Open in dashboard</a>
                                            </div>
                                        }
                                        <div className="text-right">
                                            {types.map(item =>
                                                <Link
                                                    tag="button"
                                                    to={'/account/communicate#' + objToEncoded({
                                                        commentable_id: search.commentable_id,
                                                        commentable_type: search.commentable_type,
                                                        type: item.type
                                                    })}
                                                    key={item.type}
                                                    className={'btn ms-2 mb-2 btn-' + (search.type == item.type ? 'primary' : 'light border')}
                                                >{item.label}</Link>
                                            )}
                                        </div>
                                    </div>
                                }
                                {commentable && search?.type == 'discussion' &&
                                    <div className="alert alert-warning border">
                                        <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                        Comments under the discussion section are visible publicly on the <a href="">post page</a>. 
                                        <button type="button" className="btn-close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                }
                                <FeedAccount
                                    type={search.type}
                                    commentable_id={search.commentable_id}
                                    commentable_type={search.commentable_type}
                                    onLoad={res => {
                                        setCommentable(res)
                                    }}
                                />
                            </>
                        ) : (
                            <div className="m-5 text-center">
                                <h3>Thread is not found</h3>
                                <Link tag="button" to="/account" className="btn btn-primary">Dashboard</Link>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </>
    )
}
